<div>
    <h2>{{'confeccionesDuplicar.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'confeccionesDuplicar.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')" [disabled]="disabledEtiquetador" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'confeccionesDuplicar.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominacionesList" [selectedItem]="filtersForm.get('denominacion')" [disabled]="disabled" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'confeccionesDuplicar.filters.confeccion' | translate}}</label>
                <input type="text" formControlName="desConfeccion">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-next">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="filters-buttons">
      <button [disabled]="checkDuplicar()" *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': checkDuplicar()}"
            title="{{'confeccionesDuplicar.duplicar' | translate}}" (click)="duplicar()">
            <i class="fa fa-copy"></i> {{'confeccionesDuplicar.duplicar' | translate}}
      </button>
    </section>
    <section class="tabs">
        <ul>
            <li [ngClass]="{'active': pestanaActiva === 1}" (click)="showConfeccionesCaja()">{{'confeccionesDuplicar.confeccion.tituloCaja' | translate}}</li>
            <li *ngIf="permitePallets" [ngClass]="{'active': pestanaActiva === 2}" (click)="showConfeccionesPallet()">{{'confeccionesDuplicar.confeccion.tituloPallet' | translate}}</li>
        </ul>
        <content>
            <app-confecciones-caja-duplicar *ngIf="pestanaActiva === 1" [confeccionesCaja]="confeccionesCaja" [onApplyFilters]="onApplyFilters" [onChangeTab]="onChangeTab" (refresh)="refresh($event)" (sort)="sort($event)"
            (confeccionesSelected)="confeccionesSelected=$event" (multipleConfecciones)="multipleConfecciones=$event"></app-confecciones-caja-duplicar>
            <app-confecciones-pallet-duplicar *ngIf="pestanaActiva === 2" [confeccionesPallet]="confeccionesPallet" [onApplyFilters]="onApplyFilters" [onChangeTab]="onChangeTab" (refresh)="refresh($event)" (sort)="sort($event)"
            (confeccionesSelected)="confeccionesSelected=$event" (multipleConfecciones)="multipleConfecciones=$event"></app-confecciones-pallet-duplicar>
            <app-paginator
                *ngIf="(pestanaActiva === 1 && confeccionesCaja && confeccionesCaja.length > 0) || (pestanaActiva === 2 && confeccionesPallet && confeccionesPallet.length > 0)"
                [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1" [totalItems]="totalItems"
                [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
                (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
        </content>
        <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
        </app-toast>
    </section>
</div>
<div class="modal" *ngIf="duplicarModal > 0">
  <div class="modal-content">
    <header>
      <h4>{{'confeccionesDuplicar.titulo' | translate}}</h4>
      <i class="fas fa-times" (click)="closeDuplicarModal()"></i>
    </header>
    <div>
      <content>
        <div class="filters-info">{{'global.infoRequired' | translate}}</div>
        <section class="filters-framed">
          <form [formGroup]="denominacionesForm" [ngClass]="{'show-error': showError}">
            <div class="entry-4-modal" *ngIf="denominacionesDuplicar && denominacionesDuplicar.length == 1">
              <label>{{'confeccionesDuplicar.duplicarModal.filters.denominacion' | translate}} *</label>
              <app-filterable-list [itemsList]="denominacionesDuplicar" [disabled]="disabledDuplicar" [selectedItem]="denominacionesForm.get('denominacionId')" [placeHolder]="false">
              </app-filterable-list>
            </div>
            <div class="entry-4-modal" *ngIf="denominacionesDuplicar && denominacionesDuplicar.length > 1">
              <label>{{'confeccionesDuplicar.duplicarModal.filters.denominacion' | translate}} *</label>
              <app-multiselect-list [itemsList]="denominacionesDuplicar" (shareCheckedList)="shareCheckedListDenominaciones($event)"
                  [selectedItem]="denominacionesForm.get('denominacionesId')"
                  [disabled]="disabledDuplicar" [initialState]="'allSelected'">
              </app-multiselect-list>
            </div>
          </form>
        </section>
        <br>
        <table>
          <thead>
            <tr>
              <th class="icon"></th>
              <th class="id">{{'confeccionesDuplicar.duplicarModal.table.id' | translate}}</th>
              <th class="string">{{'confeccionesDuplicar.duplicarModal.table.denominacion' | translate}}</th>
              <th class="string">{{'confeccionesDuplicar.duplicarModal.table.etiquetador' | translate}}</th>
              <th class="string">{{'confeccionesDuplicar.duplicarModal.table.confeccion' | translate}}</th>
            </tr>
          </thead>
          <tbody *ngFor="let confeccionSelected of confeccionesSelected; let i = index;">
            <tr *ngIf="i < lastItemList_modal && i >= firstItemList_modal">
              <td class="multi-icon">
                <i *ngIf="confeccionSelected.state != undefined && confeccionSelected.state === false" class="fa-regular fa-circle-xmark" style="color:red" title="{{confeccionSelected.stateMsg | translate}}"></i>
                <i *ngIf="confeccionSelected.state" class="fa-regular fa-circle-check" title="{{confeccionSelected.stateMsg | translate}}"></i>
              </td>
              <td class="id">{{confeccionSelected.id}}</td>
              <td class="string">{{confeccionSelected.desDenominacionUnica}}</td>
              <td class="string">{{confeccionSelected.desEtiquetador}}</td>
              <td class="string">{{confeccionSelected.des}}</td>
            </tr>
          </tbody>
        </table>
        <app-paginator
                  *ngIf="confeccionesSelected && confeccionesSelected.length > 0"
                  [itemsPerPage]="itemsPerPage_modal" [currentPage]="currentPage_modal" [totalItems]="totalItems_modal"
                  [visiblePages]="visiblePages_modal" (pageChange)="pageChange_modal($event)"
                  (itemsPerPageChange)="itemsPerPageChange_modal($event)"></app-paginator>
        <footer class="button-bar-right">
          <button class="secondary" (click)="closeDuplicate()">{{'global.cancelar' | translate}}</button>
          <button [disabled]="disabledDuplicarModal" [ngClass]="{'secondary-disabled': disabledDuplicarModal}" (click)="onDuplicate()">{{'confeccionesDuplicar.duplicar' | translate}}</button>
        </footer>
      </content>
    </div>
  </div>
</div>
